module.exports = __webpack_public_path__ + "img/Feedback.2b25ff50.svg";